import React, { memo } from "react";
import CaptionText from "components/Caption/components/Text";

export default memo(function Caption({ startTime, endTime = undefined, format, text}) {
  return (
    <li style={{display: 'contents'}}>
        <CaptionText text={text} />
    </li>
  );
});